export enum ErrorPageStatus {
    EXPIRED_OR_USED_ACTIVATION_LINK = "EXPIRED_OR_USED_ACTIVATION_LINK",
    EXPIRED_OR_USED_RESET_PASSWORD_LINK = "EXPIRED_OR_USED_RESET_PASSWORD_LINK",
    DUPLICATE_MEMBER_FOUND = "DUPLICATE_MEMBER_FOUND"
}